(() => {
  const HEADING_SELECTORS = [
    ".homepage-sections--title",
    ".section-header__heading",
    ".template-page h1",
    ".template-page h2",
    ".template-product h1",
    ".template-product h2"
  ];

  function hasLineBreak(html) {
    return /<br\s*\/?>/i.test(html || "");
  }

  function splitHeading(el) {
    if (!el || el.classList.contains("jit-split-heading")) return;
    const html = el.innerHTML;
    if (!hasLineBreak(html)) return;

    const parts = html
      .split(/<br\s*\/?>/gi)
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.length < 2) return;

    const line1 = parts[0];
    const line2 = parts.slice(1).join(" ");

    el.innerHTML =
      `<span class="jit-heading-line jit-heading-line--1">${line1}</span>` +
      `<span class="jit-heading-line jit-heading-line--2">${line2}</span>`;
    el.classList.add("jit-split-heading");
  }

  function initSplitHeadings(root = document) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(HEADING_SELECTORS.join(",")).forEach(splitHeading);
  }

  document.addEventListener("DOMContentLoaded", () => initSplitHeadings(document));
  document.addEventListener("shopify:section:load", (event) => initSplitHeadings(event.target));
  document.addEventListener("shopify:section:reorder", () => initSplitHeadings(document));
})();

